import styled from "styled-components"
import { Colors } from "styles/app-styles"
import DataTable_s from "components/table/data-table-styles"

export const ReportPropertyGrid_s = styled.div`
  background: ${Colors.white};
  border: 1px solid ${Colors.towerGrey};
  padding: 10px;
  position: relative;
  ${DataTable_s}{ padding-bottom: 0; }
  .p-datatable-thead > tr > th.p-filter-column:first-child > div.p-checkbox {
    display: none;
  }
  .p-datatable-footer { padding: 0; }
  .p-dropdown-panel {
    background-color: white;
    border: 1px solid black;
  }
`

export const SelectAll_s = styled.div`
  margin: 35px 0 0 1px;
  position: absolute;
  z-index: 10;
  > div.p-checkbox {
    border: 1px solid ${Colors.towerGrey};
    > div.p-checkbox-box {
      height: 16px;
      width: 16px;
      .pi-check:before { font-size: 12px; font-weight: bold; }
    }
  }
`

export const SelectionMethod_s = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`

export const SelectionGrid_s = styled.div`
  background: ${Colors.inputFocus};
  border: 1px solid ${Colors.towerGrey};
  margin: 0;
  padding: 10px;
`

export const PropertyMetrics_s = styled.div`
  width: 100%;
  .filled-form-row {
    background: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    display: flex;
    padding: 15px;
    > div {
      display: flex;
      flex-direction: column;
      margin-right: 15px;
    }
  }
  .select-lists {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px 15px;
    margin: 15px;
    > div {
      min-width: 230px;
    }
    > div > div.p-listbox.p-component {
      max-height: 185px !important;
      overflow: auto;
    }
  }
`